import React, { useEffect } from 'react'
import { useWordPressPage } from '../uses/useWordPressPage'
import { useWordPressGlossaires } from '../uses/useWordPressGlossaires'
import FullPageLayout from '../components/FullPageLayout'

const path = require('path')

const SLUG = path.basename(__filename).split('.')[0]

export default () => {
  const page = useWordPressPage(SLUG)
  const glossaires = useWordPressGlossaires()

  useEffect(() => {
    if (window) {
      const slug = window.location.hash.replace('#', '')
      if (slug !== '') {
        window.location.hash = slug
      }
    }
  }, [])

  return (
    <FullPageLayout>
      <div className="glossary-wrapper">
        <h1>{page.title}</h1>
        <div
          className="headlines"
          dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
        />
        {glossaires.map(node => (
          <div key={node.slug} className="glossary-item">
            <div id={node.title} className="glossary-anchor" />
            <div className="abbreviation">{node.title}</div>
            <div
              className="explanation"
              dangerouslySetInnerHTML={{ __html: node.content }}
            />
          </div>
        ))}
      </div>
    </FullPageLayout>
  )
}
